import type { CustomerInfo, PageInfo } from '@@partner:types:app'
import type {
  CommonPager,
  NestedFilter,
  CommonSort
} from '@@partner:types:graphql'

import { gql, useQuery } from '@apollo/client'

import {
  SHORTCUT_PAGE_INFO_FIELDS,
  SHORTCUT_CUSTOMERS_FIELDS
} from '@@partner:graphql/shortcuts'

export interface AllCustomersQuery {
  allCustomers: {
    edges: CustomerInfo[]
    pageInfo: PageInfo
  }
}
export interface AllCustomersQueryVariables {
  filter?: NestedFilter
  sort?: CommonSort
  pager: CommonPager
}

export const GQL_QUERY_ALL_CUSTOMERS = gql`
  query (
    $filter: NestedFilterInput
    $pager: CommonPagerInput
    $sort: CommonSortInput
  ) {
    allCustomers(
      filter: $filter
      sort: $sort
      pager: $pager
    ) {
      edges {
        ${SHORTCUT_CUSTOMERS_FIELDS}
      }
      pageInfo {
        ${SHORTCUT_PAGE_INFO_FIELDS}
      }
    }
  }
`

export const useFetchAllCustomers = (variables: AllCustomersQueryVariables) =>
  useQuery<AllCustomersQuery, AllCustomersQueryVariables>(
    GQL_QUERY_ALL_CUSTOMERS,
    {
      variables,
      fetchPolicy: 'cache-and-network'
    }
  )
